export const TACTICAL_META = {
  "30": { name: "Blink", image: "/assets/loadout/tactical/01. Blink.png" },
  "40": { name: "Quake", image: "/assets/loadout/tactical/02. Quake.png" },
  "50": { name: "Protocol Violation", image: "/assets/loadout/tactical/03. Protocol Violation.png" },
  "60": { name: "Electric Shift", image: "/assets/loadout/tactical/04. Electric Shift.png" },
  "70": { name: "Force Field", image: "/assets/loadout/tactical/05. Force Field.png" },
  "80": { name: "Totem", image: "/assets/loadout/tactical/06. Totem.png" },
  "90": { name: "Nullification", image: "/assets/loadout/tactical/07. Nullification.png" },
  "110": { name: "Soul Stealer", image: "/assets/loadout/tactical/08. Soul Stealer.png" },
  "120": { name: "The Strijder", image: "/assets/loadout/tactical/09. The Strijder.png" },
  "130": { name: "Blade of Truth", image: "/assets/loadout/tactical/10. Blade of Truth.png" },
  "140": { name: "False Oath", image: "/assets/loadout/tactical/11. False Oath.png" },
  "150": { name: "Healing Wind", image: "/assets/loadout/tactical/12. Healing Wind.png" },
  "160": { name: "리펄서 미사일", image: "/assets/loadout/tactical/리펄서 미사일.webp" },
  "170": { name: "플라즈마 대시", image: "/assets/loadout/tactical/플라즈마 대시.webp" },
};
